import * as $ from 'jquery';
import ToggleActive from './modules/toggle-active';
import "babel-polyfill";

$(function () {

  let smWidth = 647;

  // Toggle Active on Mobile Menu Icon
  new ToggleActive({
    evts: ['click'],
    addOrRemove: 'toggle',
    currElm: '.mob-menu-icon--js',
    func: function (e, cb) {
      $('nav').toggleClass('mob-menu-open');
      cb();
    }
  });

  // Toggle Active on Footer menu header
  new ToggleActive({
    evts: ['click'],
    addOrRemove: 'toggle',
    currElm: '.footer-menu__title--js',
    func: function (e, cb) {
      if (window.innerWidth <= 799 && !$(e.target).closest('.footer-menu__body').length) {
        cb();
      }
    }
  });

  // Add Active on Footer Help Icon
  new ToggleActive({
    evts: ['mouseover', 'click'],
    addOrRemove: 'add',
    currElm: '.help-info-icon--js',
    setElms: ['li']
  });

  // Remove Active on Footer Help Icon
  new ToggleActive({
    evts: ['mouseleave'],
    addOrRemove: 'remove',
    currElm: '.help-info-icon--js',
    setElms: ['li']
  });

  // Add active on mouseenter on Nav LI on Desktop
  new ToggleActive({
    evts: ['mouseenter'],
    addOrRemove: 'add',
    currElm: '.top-nav--js > li > a:not(.btn)',
    setElms: ['li'],
    func: avoidOnSmall,
    preventDef: true
  });

  // Toggle active on Nav LI
  new ToggleActive({
    evts: ['click'],
    addOrRemove: 'toggle',
    currElm: '.top-nav--js > li:not(.btn-order)',
    func: function (e, cb) {
      if (!$(e.target).closest('li').hasClass('active')) {
        $(this.currElm).removeClass('active');
      }
      cb();
    }
  });

  // Remove active on LI
  new ToggleActive({
    evts: ['mouseleave'],
    addOrRemove: 'remove',
    currElm: '.top-nav--js > li',
    func: avoidOnSmall
  });

  // Add active on subnav LI
  new ToggleActive({
    evts: ['mouseover'],
    addOrRemove: 'add',
    currElm: '.top-sub-nav__list--js a',
    setElms: ['li'],
    func: function (e, cb) {
      if (window.innerWidth > smWidth) {
        e.preventDefault();
        const $currElm = $(e.currentTarget);
        const $parentLi = $currElm.closest('li');
        const $parentUl = $currElm.closest('.top-sub-nav__list--js');
        const $parentUlB = $parentUl.find('.top-sub-nav__list__b--js');
        const liHeight = $parentLi[0].clientHeight;
        const listItem = +$parentLi.data('list-item');
        const $selItem = $parentLi.closest('.top-sub-nav').find('[data-item-selected="' + listItem + '"]');
        $parentLi.closest('.top-sub-nav').find('[data-item-selected]').removeClass('active');
        if ($selItem.css('left') === '0px') {
          $selItem.css('left', '-' + $selItem[0].offsetLeft + 'px');
        }
        $selItem.addClass('active');
        $parentUl.find('li').removeClass('active');
        $parentUlB.css('top', (liHeight * (listItem) - liHeight) + 'px');
        cb();
      }
    }
  });


  // Reset the active on Navs while clicking outside of the nav
  $(document).on('click', function (e) {
    if (window.innerWidth <= smWidth) {
      if (!$(e.currentTarget).closest('header').length) {
        resetActiveClass();
      }
    }
  });

  // Cart icon redirection
  $('#cart-item-link').on('click', function (e) {
    e.preventDefault();
    const $cartElm = $('#cart-onclick');
    if ($cartElm.length) {
      $cartElm.click();
      $("#modalDiv").addClass("custom-cart-modal-design");
    } else {
      window.location.href = '/getting-started';
    }
  })

  windowResized();

  $(window).resize(windowResized);

  // To avoid to run the callback on small devices in some cases
  function avoidOnSmall(e, cb) {
    if (window.innerWidth > smWidth) {
      cb();
    }
  }

  // To set the classes to its initial state
  function resetActiveClass() {
    $('nav').removeClass('mob-menu-open');
    $('.mob-menu-icon--js').removeClass('active');
    $('.help-info').removeClass('active');
  }

  // On window resizing set the responsiveness of header navigation.
  function windowResized() {
    const section = Array.from(document.querySelectorAll('.top-sub-nav__section'));
    resetActiveClass();
    section.map(elm => {
      const $selElm = $(elm).find('[data-item-selected]');
      const $sibLi = $(elm).closest('.top-sub-nav--js').find('.top-sub-nav__list--js li');
      const elmWidth = (Math.floor($(elm).width())) + 'px';
      $selElm.css({
        'left': '0px',
        'max-width': elmWidth,
        'width': elmWidth
      });
      $selElm.removeClass('active');
      $($selElm[0]).addClass('active');
      $sibLi.removeClass('active');
      $($sibLi[0]).addClass('active');
      $(elm).closest('.top-sub-nav--js').find('.top-sub-nav__list__b--js').css('top', '0px');
    });
  }

});


// WEBPACK FOOTER //
// ./resources/assets/scripts/main.js